import { ProductCard } from './ProductCard';
import type { Product } from '@shared/types/product.types';

interface ProductGridProps {
  products: Product[];
  isLoading?: boolean;
}

function ProductSkeleton() {
  return (
    <div className="animate-pulse rounded-xl border border-white/10 bg-navy-900/50 overflow-hidden">
      <div className="aspect-video bg-navy-800" />
      <div className="p-4 space-y-3">
        <div className="h-5 w-3/4 rounded bg-navy-800" />
        <div className="h-4 w-1/4 rounded bg-navy-800" />
        <div className="h-6 w-1/3 rounded bg-navy-800" />
      </div>
    </div>
  );
}

export function ProductGrid({ products, isLoading }: ProductGridProps) {
  if (isLoading) {
    return (
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {Array.from({ length: 6 }, (_, i) => (
          <ProductSkeleton key={i} />
        ))}
      </div>
    );
  }

  if (products.length === 0) {
    return (
      <div className="py-12 text-center">
        <p className="text-gray-500">No products found</p>
      </div>
    );
  }

  return (
    <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
      {products.map((product) => (
        <ProductCard
          key={product.id}
          name={product.name}
          slug={product.slug}
          price={product.priceOneTime}
          thumbnailUrl={product.thumbnailUrl}
          isFeatured={product.isFeatured}
          isComingSoon={product.isComingSoon}
          categoryName={product.category?.name}
          reviewCount={(product as unknown as { _count?: { reviews: number } })._count?.reviews}
        />
      ))}
    </div>
  );
}
